import React from 'react';
import { Heart, Users, CalendarHeart, Sparkles, CircleCheck, MessageCircle, Star } from 'lucide-react';
import '../../styles/website/MatchmakingSection.css';

const MatchmakingSection = () => {
  return (
    <section className="premium-section matchmaking-section" id="matchmaking">
      <div className="premium-container">
        <div className="premium-icon-wrapper">
          <div className="premium-icon">
            <Heart size={64} />
          </div>
          <div className="icon-glow"></div>
        </div>
        
        <div className="premium-content">
          <span className="premium-badge">Relationship Insights</span>
          <h2 className="premium-title">Matchmaking and Compatibility</h2>
          <p className="premium-tagline">Clear compatibility for strong relationships.</p>
          
          <p className="premium-description">
            See how well two people match — for relationship, marriage, long-term life, and overall harmony.
          </p>
          
          <div className="premium-features">
            <div className="feature-item">
              <Star size={20} />
              <span>Relationship strength score</span>
            </div>
            <div className="feature-item">
              <Heart size={20} />
              <span>Marriage compatibility</span>
            </div>
            <div className="feature-item">
              <MessageCircle size={20} />
              <span>Emotional, practical & long-term match</span>
            </div>
            <div className="feature-item">
              <CalendarHeart size={20} />
              <span>Timing for marriage</span>
            </div>
            <div className="feature-item">
              <CircleCheck size={20} />
              <span>Stability of married life</span>
            </div>
            <div className="feature-item">
              <Users size={20} />
              <span>Spouse nature & bonding pattern</span>
            </div>
            <div className="feature-item">
              <Sparkles size={20} />
              <span>Partnership lifetime overview</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MatchmakingSection;
